import React, { useEffect, useState } from "react";
import { Translation } from "react-i18next";
import i18next from "i18next";
import Page from "../general/Page";
import { useLocation } from "react-router-dom/cjs/react-router-dom.min";
import { Spin, Card, Button, Popconfirm } from "antd";
import vodafone from "../../resource/vodafoneIVR.png";
import { handleError } from "../../utils/ErrorHandlers";
import { invitationService } from "../../services/invitation/InvitationService";
import "./Invitations.css";
import { da } from "date-fns/locale";
import { showErrorToast, showSuccessToast } from "../general/ToastHelper";
import history from "../../utils/history";
import withSharedStateConsumer from "../../contexts/shared-state/withSharedStateConsumer";

function ViewInvitationComponent(props) {
  const location = useLocation();
  const invitationToken = location.pathname.slice(8);
  const [isFetching, setIsFetching] = useState(false);
  const [invitation, setInvitation] = useState();
  const [authToken, setAuthToken] = useState();

  const [lang, setLang] = useState("ar");

  useEffect(() => {
    getAuthToken();
  }, []);
   useEffect(() => {
    if (lang) {
      switchLanguage(lang)
    }
  }, [lang]);

   const switchLanguage = (key) => {
    i18next.changeLanguage(key);
    props.context.updateLangAndDir(key, key === "en" ? "ltr" : "rtl");
    document.querySelector("html").dir = key === "en" ? "ltr" : "rtl";
    sessionStorage.setItem("dir", key === "en" ? "ltr" : "rtl");
  }

  const getAuthToken = async () => {
    setIsFetching(true);
    try {
      const response = await invitationService.getCSRFAuthToken();
      const data = await response.json();
      setAuthToken(data.token);
      getInvitationDetailsByToken(invitationToken, data.token);
    } catch (e) {
      setIsFetching(false);
      handleError(e);
    }
  };

  const getInvitationDetailsByToken = async (invitationToken) => {
    try {
      const response = await invitationService.getInvitationByToken(
        invitationToken
      );
      const data = await response.json();
      setInvitation(data.ivrCustomEntityObject);
    //   const responseLang =
    //     data.statusCode && data.statusCode !== 0
    //       ? data?.language
    //       : data?.ivrCustomEntityObject?.language;
    //   setLang(responseLang === "ar" ? "ar" : "en");
      setIsFetching(false);
    } catch (e) {
      setIsFetching(false);
      handleError(e);
    }
  };

  const accpetInvitation = async () => {
    try {
      setIsFetching(true);
      const data = await invitationService.acceptInvitation(
        authToken,
        invitationToken
      );
      setIsFetching(false);
      if (data.statusCode != 0) {
        showErrorToast(data.statusMsg);
      } else {
        showSuccessToast(i18next.t("Invitation Accepted"));
        history.push("/login");
      }
    } catch (e) {
      setIsFetching(false);
      handleError(e);
    }
  };

  const rejectInvitation = async () => {
    try {
      setIsFetching(true);
      const data = await invitationService.rejectInvitation(
        authToken,
        invitationToken
      );
      setIsFetching(false);
      if (data.statusCode != 0) {
        showErrorToast(data.statusMsg);
      } else {
        showSuccessToast(i18next.t("Invitation rejected"));
      }
    } catch (e) {
      setIsFetching(false);
      handleError(e);
    }
  };

  return (
    <Translation>
      {(t) => (
        <Page>
          <div
            className="main-div"
            style={{ background: "#ECECEC", padding: "30px" }}
          >
            <Card bordered={false} className="responsive-card">
              <img src={vodafone} className="img" />
              <h3 style={{ textAlign: "center" }}>
                {i18next.t("Invitation details")}
              </h3>

              {isFetching ? (
                <div className="spinner">
                  <Spin></Spin>
                </div>
              ) : invitation?.expired == true ? (
                <div>
                  <h3 style={{ textAlign: "center" }}>
                    Sorry, Invitation Invalid
                  </h3>
                  <p className="invalid-inv">
                    Invitaion is invalid due to being expired{" "}
                  </p>
                </div>
              ) : invitation?.invitationStatus === "PENDING" ? (
                <div>
                  {/* <p className="p-inv-text">Invitation ID: {invitation.invitationId}</p>
                                                <p className="p-inv-text">Invitation Status: {invitation.invitationStatus}</p> */}
                  <p className="p-inv-text">
                    {i18next.t("User Name")}
                    <span className="space">:</span> {invitation?.userName}
                  </p>
                  <p className="p-inv-text">
                    {i18next.t("User Number")}
                    <span className="space">:</span>
                    {invitation?.userNumber}
                  </p>
                  <p className="p-inv-text">
                    {i18next.t("Account Name")}
                    <span className="space">:</span> {invitation?.accountName}
                  </p>
                  <div className="button-group">
                    <Popconfirm
                      title={i18next.t(
                        "Are you sure you want to accept this invitation?"
                      )}
                      onConfirm={accpetInvitation}
                      okText={i18next.t("Yes")}
                      cancelText={i18next.t("No")}
                    >
                      <Button type="primary" className="acccept-button">
                        {i18next.t("Accept")}
                      </Button>
                    </Popconfirm>
                    <Popconfirm
                      title={i18next.t(
                        "Are you sure you want to reject this invitation?"
                      )}
                      onConfirm={rejectInvitation}
                      okText={i18next.t("Yes")}
                      cancelText={i18next.t("No")}
                    >
                      <Button type="primary" className="decline-button">
                        {i18next.t("Decline")}
                      </Button>
                    </Popconfirm>
                  </div>
                </div>
              ) : (
                <div>
                  <h3 style={{ textAlign: "center" }}>
                    {i18next.t("Sorry, Invitation Invalid")}
                  </h3>
                  <p className="invalid-inv">
                    {i18next.t("Invitation is invalid due to being")}{" "}
                    {invitation?.invitationStatus == undefined
                      ? i18next.t("not found")
                      : i18next.t(invitation.invitationStatus)}
                  </p>
                </div>
              )}
            </Card>
          </div>
        </Page>
      )}
    </Translation>
  );
}
export default withSharedStateConsumer(ViewInvitationComponent);
